// Sleepify Starter Theme by Sleepless Media
//
// Main Javascript entry file. 

console.log('%c This site was designed & developed by https://www.sleeplessmedia.com', 'background:#000; line-height: 30px; color: #ae956e; padding: 10px 5px; font-size: 13px; font-weight: 500; width: 100%;');

// Create our number formatter.
var formatter = new Intl.NumberFormat('en-US', {
  style: 'currency',
  currency: 'USD'

  // These options are needed to round to whole numbers if that's what you want.
  //minimumFractionDigits: 0, // (this suffices for whole numbers, but will print 2500.10 as $2,500.1)
  //maximumFractionDigits: 0, // (causes 2500.99 to be printed as $2,501)
});

// Cookies functions
function setCookie(cookieName, cookieValue) {
  var today = new Date();
  var expire = new Date();
  expire.setTime(today.getTime() + 3600000 * 24 * 7);
  document.cookie = cookieName + "=" + encodeURI(cookieValue) + ";expires=" + expire.toGMTString();
}
function getCookie(cname) {
  var name = cname + "=";
  var decodedCookie = decodeURIComponent(document.cookie);
  var ca = decodedCookie.split(';');
  for (var i = 0; i < ca.length; i++) {
    var c = ca[i];
    while (c.charAt(0) == ' ') {
      c = c.substring(1);
    }
    if (c.indexOf(name) == 0) {
      return c.substring(name.length, c.length);
    }
  }
  return "";
}
jQuery(document).ready(function ($) {
  // Simple accordion functionality
  $('.accordion__group button').on('click', function (e) {
    e.preventDefault();
    var $currentAccordionGroup = $(this).closest('.accordion__group');
    var $currentButton = $(this);
    var isCurrentlyOpen = $currentAccordionGroup.hasClass('active');

    // Close all other accordions
    $('.accordion__group').not($currentAccordionGroup).removeClass('active').find('button').attr('aria-expanded', 'false');
    $('.accordion__copy').not($currentAccordionGroup.find('.accordion__copy')).slideUp().attr('aria-hidden', 'true');
    if (!isCurrentlyOpen) {
      // Open the clicked accordion if it was not already open
      $currentAccordionGroup.addClass('active');
      $currentButton.attr('aria-expanded', 'true');
      $currentAccordionGroup.find('.accordion__copy').slideDown().attr('aria-hidden', 'false');
    } else {
      // Close the clicked accordion if it was already open
      $currentAccordionGroup.removeClass('active');
      $currentButton.attr('aria-expanded', 'false');
      $currentAccordionGroup.find('.accordion__copy').slideUp().attr('aria-hidden', 'true');
    }
  });

  // Initialize ARIA attributes
  $('.accordion__group').find('button').attr('aria-expanded', 'false');
  $('.accordion__group.active').find('button').attr('aria-expanded', 'true');
  $('.accordion__copy').attr('aria-hidden', 'true');
  $('.accordion__group.active .accordion__copy').attr('aria-hidden', 'false');
});
jQuery(document).ready(function ($) {
  // Show / hide address add form
  $('.customer--addresses .add-address').on('click', function (e) {
    $('#address-add').toggle();
    $('#address-list').toggle();
  });

  // Show / hide address add form
  $('.customer--addresses .add-address-cancel').on('click', function (e) {
    $('#address-add').toggle();
    $('#address-list').toggle();
  });
});
jQuery(document).ready(function ($) {
  /******************************************
   QTY Selector ( Simple quantity box increase / decrease )
  ******************************************/

  // PDP / PLP
  $('.js-qty:not(.js-qty--cart)').on('click', function (e) {
    e.preventDefault();
    var $this = $(this);
    var $parent = $this.parent();
    var qtyInput = $parent.find('input');
    var qtyInputVal = qtyInput.val();
    qtyInputVal = $.isNumeric(qtyInputVal) ? qtyInputVal : 1;
    if ($this.hasClass('js-qty--plus')) {
      qtyInputVal++;
      qtyInputVal = qtyInputVal < 1 ? 1 : qtyInputVal;
    } else {
      qtyInputVal--;
      qtyInputVal = qtyInputVal < 1 ? 0 : qtyInputVal;
    }
    qtyInput.val(qtyInputVal);
  });
  $('body').on('click', '.product--default .btn--atc', function () {
    var id = $(this).attr('data-id');
    CartJS.addItem(parseInt(id), 1, {}, {
      "success": function success(data, textStatus, jqXHR) {
        jQuery.getJSON('/cart.js', function (cart) {
          refreshMiniCart(cart);
        });
      },
      "error": function error(jqXHR, textStatus, errorThrown) {
        //error state
        console.log('Error: ' + errorThrown + '!');
      }
    });
  });

  // MAIN CART
  $('.template__cart').on('click', '.col__qty .js-qty--cart, .mobile-stuff .js-qty--cart', function (e) {
    e.preventDefault();
    var $this = $(this);
    var qtyInput = $this.closest('.qty').find('input');
    var qtyInputVal = qtyInput.val();
    qtyInputVal = $.isNumeric(qtyInputVal) ? qtyInputVal : 1;
    var lineNum = $this.closest('.cart-row').attr('data-linenum');
    if ($this.hasClass('js-qty--plus')) {
      qtyInputVal++;
      qtyInputVal = qtyInputVal < 1 ? 1 : qtyInputVal;
    } else {
      if (qtyInputVal <= 1) {
        CartJS.removeItem(lineNum, {
          success: function success(data, textStatus, jqXHR) {
            location.reload();
            // jQuery.getJSON('/cart.js', function(cart) {
            //   refreshCartPage(cart);
            // });      
          },

          error: function error(jqXHR, textStatus, errorThrown) {
            jQuery.getJSON('/cart.js', function (cart) {
              refreshCartPage(cart);
            });
            var response = jqXHR.responseJSON;
            var message = jqXHR.responseJSON.message;
            console.log(response);
            if (jqXHR.status === 422) {
              alert('Error: ' + message);
            }
          }
        });
        return; // Make sure to stop execution after removing the item.
      }

      qtyInputVal--;
    }

    // Update the quantity in the cart
    if (qtyInputVal >= 1) {
      CartJS.updateItem(lineNum, qtyInputVal, {}, {
        success: function success(data, textStatus, jqXHR) {
          // location.reload();  
          jQuery.getJSON('/cart.js', function (cart) {
            refreshCartPage(cart);
          });
        },
        error: function error(jqXHR, textStatus, errorThrown) {
          jQuery.getJSON('/cart.js', function (cart) {
            refreshCartPage(cart);
          });
          var response = jqXHR.responseJSON;
          var message = jqXHR.responseJSON.message;
          console.log(response);
          if (jqXHR.status === 422) {
            alert('Error: ' + message);
          }
        }
      });
    }
  });

  // Disable click into qty val field
  $('body').on('keydown', '.qty-val', function (e) {
    e.preventDefault();
  });

  // MAIN CART REMOVE
  $('body').on('click', '.actions .remove-product', function (e) {
    e.preventDefault();
    var $this = $(this);
    var lineID = $this.closest('.cart-row').attr('data-lineid');
    CartJS.removeItemById(lineID, {
      success: function success(data, textStatus, jqXHR) {
        location.reload();
      },
      error: function error(jqXHR, textStatus, errorThrown) {}
    });
  });

  /******************************************
    Options to change SM-RC Widget dropdowns 
   ******************************************/

  // SELECT TYPE
  $('.option__wrap select').on('change', function () {
    var optionVal = $(this).val();
    var optionNum = $(this).closest('.option__wrap').attr('data-option');
    $('select[' + optionNum + ']').val(optionVal).change();
  });

  // BUTTON TYPE
  $('.option__wrap button').on('click', function (e) {
    var optionVal = $(this).attr('data-val');
    var optionNum = $(this).closest('.option__wrap').attr('data-option');

    // Set visual display of active
    $(this).closest('.option__wrap').find('button').removeClass('active');
    $(this).addClass('active');
    $('select[' + optionNum + ']').val(optionVal).change();
  });

  // RECHARE WIDGET VARIANTS
  $('.pdp__recharge input').on('click', function () {
    if ($(this).val() == 'rc-yes') {
      $('.form__group--rc').show();
      var planId = $(this).closest('.pdp__recharge').find('.frequency-select').val();
      $('[sm-rc-plan-selector]').val(planId).change();
    } else {
      $('.form__group--rc').hide();
      $('[sm-rc-plan-selector]').val('false').change();
    }
  });

  // RECHARE WIDGET SUBSCRIPTION PLAN
  $('.template__product .frequency-select').on('change', function () {
    var planId = $(this).val();
    $('[sm-rc-plan-selector]').val(planId).change();
  });
});
function refreshCartPage(cartData) {
  var cartItems = cartData.items;
  var newCartHtml = '';

  // Free shipping updater
  var totalShip = parseInt($('.cart').data('freeship'));
  var newCartTotal = cartData.items_subtotal_price;
  var awayShip = totalShip - newCartTotal;
  var shipPercent = newCartTotal / totalShip * 100;
  if (shipPercent >= 100) {
    $('.shipping-bar--progress').css('width', '100%');
    $('.mini-cart__ship').addClass('is-free');
  } else {
    if ($('.mini-cart__ship').hasClass('is-free')) {
      $('.mini-cart__ship').removeClass('is-free');
    }
    $('.free-count').text(formatter.format(awayShip / 100));
    $('.shipping-bar--progress').css('width', shipPercent + '%');
  }
  $.each(cartItems, function (index, item) {
    newCartHtml += '<tr class="cart-row" data-varid="' + item.id + '" data-lineid="' + item.key + '" data-linenum="' + (index + 1) + '">';
    newCartHtml += '<td class="col col__product" width="40%">';
    newCartHtml += '<div class="d-flex">';
    newCartHtml += '<div class="product__image">';
    newCartHtml += '<a href="' + item.url + '">';
    newCartHtml += '<img src="' + item.featured_image.url.replace('.jpg', '_80x.jpg').replace('.png', '_80x.png') + '" srcset="' + item.featured_image.url.replace('.jpg', '_160x.jpg').replace('.png', '_160x.png') + ' 2x" alt="' + item.title + '">';
    newCartHtml += '</a>';
    newCartHtml += '</div>';
    newCartHtml += '<div class="title">';
    newCartHtml += '<h3 class="heading--five black hover-purple">';
    newCartHtml += '<a class="no-dec trans black hover-purple" href="' + item.url + '">';
    newCartHtml += item.product_title;
    newCartHtml += '</a>';
    newCartHtml += '</h3>';
    if (item.options_with_values && item.options_with_values.length > 0) {
      item.options_with_values.forEach(function (option) {
        newCartHtml += '<span class="var">' + option.name + ': ' + option.value + '</span>';
      });
    }
    if (item.selling_plan_allocation && item.selling_plan_allocation.selling_plan.name) {
      newCartHtml += '<span class="delivery">' + item.selling_plan_allocation.selling_plan.name + '</span>';
    }
    newCartHtml += '<div class="actions">';
    newCartHtml += '<button class="remove-product trans hover-opacity d-flex align-center">';
    newCartHtml += '<img src="https://cdn.shopify.com/s/files/1/0250/8311/7615/files/modal-close.svg?v=1689107517" alt="" /><span class="eyebrow">Remove</span>';
    newCartHtml += '</button>';
    newCartHtml += '</div>';
    newCartHtml += '</div>';
    newCartHtml += '</div>';
    newCartHtml += '</td>';
    newCartHtml += '<td class="col col__price text-center">';
    newCartHtml += '<p>' + formatter.format(item.price / 100) + '</p>';
    newCartHtml += '</td>';
    newCartHtml += '<td class="col col__qty  text-center">';
    newCartHtml += '<div class="qty d-flex align-center">';
    newCartHtml += '<button class="js-qty js-qty--cart js-qty--minus trans"><span class="sr-only">Decrease</span></button>';
    newCartHtml += '<input readonly sm-rc-quantity-selector type="text" value="' + item.quantity + '" min="1" type="number" class="qty-val" />';
    newCartHtml += '<button class="js-qty js-qty--cart js-qty--plus trans"><span class="sr-only">Increase</span></button>';
    newCartHtml += '</div>';
    newCartHtml += '</td>';
    newCartHtml += '<td class="col col__total text-right">';
    newCartHtml += '<p>' + formatter.format(item.line_price / 100) + '</p>';
    newCartHtml += '</td>';
    newCartHtml += '</tr>';
  });

  // Clear current products in cart
  $('.cart__table tbody').empty();

  // Set new subtotal
  $('.cart__footer .totals .total-money').text(formatter.format(cartData.total_price / 100));

  // Set new header icon count
  $('.icon--cart .cart-count span ').text(cartData.item_count);

  // Add updated products to cart
  $('.cart__table tbody').html(newCartHtml);
}
jQuery(document).ready(function ($) {
  // Make mobile category selector go to tag page
  $('.blog__tags select').on('change', function () {
    var tagUrl = $(this).val();
    window.location = tagUrl;
  });
});
jQuery(document).ready(function ($) {
  /******************************************
     Event Tabs
   ******************************************/

  /******************************************
      Event Tabs
  ******************************************/

  // Set the first tab and its content to active
  $('.event__tabs--tabs .btn--tab').first().addClass('active');
  $('.event__tabs--content > div').first().show();
  $('.event__tabs--tabs .btn--tab').on('click change', function () {
    var tabVal;

    // If it's the dropdown, get the selected option value
    if ($(this).is('select')) {
      tabVal = $(this).find('option:selected').val();
    } else {
      // remove active class from all tabs
      $('.event__tabs--tabs .btn--tab').removeClass('active');

      // add active class to clicked tab
      $(this).addClass('active');

      // get the value of the clicked tab
      tabVal = $(this).val();
    }

    // hide all tab content
    $('.event__tabs--content > div').hide();

    // fade in the content of the clicked tab
    $('.event__tabs--content > div[data-tab=' + tabVal + ']').fadeIn();
  });

  // New code to handle dropdown change
  $('.event__tabs--dropdown select').on('change', function () {
    // Get the value of the selected option
    var tabVal = $(this).val();

    // Hide all tab content
    $('.event__tabs--content > div').hide();

    // Show the content of the selected tab
    $('.event__tabs--content > div[data-tab=' + tabVal + ']').show();
  });

  /******************************************
     Header Search
   ******************************************/

  // Show desktop search on click and focus on input
  $('.icon--search').on('click', function (e) {
    e.preventDefault();
    $('.desktop-search').fadeIn('fast', '', function () {
      $('body').addClass('search-open');
      $('.desktop-search input').focus();
    });
  });

  // Close desktop search if click outside
  $('body').on('click', function (e) {
    var desktopSearch = $('.desktop-search');
    if (!desktopSearch.is(e.target) && desktopSearch.has(e.target).length === 0 && $('body').hasClass('search-open')) {
      desktopSearch.fadeOut('fast', '', function () {
        $('body').removeClass('search-open');
        $('.icon--search').focus();
      });
    }
  });

  /******************************************
    Mobile Menu
  ******************************************/

  // Trigger mobile menu display
  $('.header__mobile-trigger button').on('click', function () {
    $(this).toggleClass('is-active');
    $('.mobile-menu').fadeToggle('fast', '', function () {});
    $('html').toggleClass('mobile-menu-open');
  });

  /******************************************
    Modals
  ******************************************/

  // Launch the modal
  $('.btn--modal').on('click', function (e) {
    e.preventDefault();
    var modalID = '#' + $(this).attr('data-modal');
    if ($(this)[0].hasAttribute('data-video-yt')) {
      var videoID = $(this).attr('data-video-yt');
      $(modalID).find('.modal__inner').append('<div class="iframe-wrap"><iframe width="560" height="315" src="https://www.youtube.com/embed/' + videoID + '" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe></div>');
    }
    if ($(this)[0].hasAttribute('data-video-vimeo')) {
      var videoID = $(this).attr('data-video-vimeo');
      $(modalID).find('.modal__inner').append('<div class="iframe-wrap"><iframe width="560" height="315" src="https://player.vimeo.com/video/' + videoID + '"  frameborder="0" allow="autoplay; fullscreen; picture-in-picture" allowfullscreen allowfullscreen></iframe></div>');
    }
    $(modalID).fadeIn('fast');
    $(modalID).find('.modal--close').focus();
  });

  // Close the modal
  $('.modal--close, .modal__bg').on('click', function (e) {
    closeModal($(this).closest('.modal'));
  });

  // Close modal with ESC key
  $(document).on('keydown', function (event) {
    if (event.key === "Escape") {
      if ($('.modal').is(':visible')) {
        closeModal($('.modal:visible'));
      }
    }
  });
});

// Close modal function
function closeModal(modal) {
  modal.fadeOut('fast', function () {
    modal.find('.modal__inner .iframe-wrap').remove();
  });
}
jQuery(document).ready(function ($) {
  $('.child_level--trigger').click(function () {
    var $menuWrap = $(this).closest('.parent_level--li').find('.child_level--wrap');
    $menuWrap.toggle();
  });

  // click menu item with children, close main menu, open matching sub panel
  $('.mobile-menu .top__level--link').on('click', function (e) {
    if ($(this).attr('href') == "#") {
      e.preventDefault();
      var dataMenu = $(this).data('menu-index');
      $('.search-bar--mobile, .mobile-menu__icons, .mobile-menu__footer').fadeOut('fast');
      $('.mobile-menu__main').fadeOut('fast', function () {
        $('.mobile-menu__sub .nav__page[data-menu-index="' + dataMenu + '"]').fadeIn('fast');
      });
    }
  });

  // close sub panel, open main menu
  $('.mobile-menu__sub .back_to_main').on('click', function (e) {
    e.preventDefault();
    var dataParentMenu = $(this).closest('.nav__page').data('menu-index');
    $(this).closest('.nav__page').fadeOut('fast', function () {
      $('.mobile-menu__main').fadeIn('fast');
      $('.search-bar--mobile, .mobile-menu__icons, .mobile-menu__footer').fadeIn('fast');
    });
  });

  // Init header offset function
  headerOffset();

  // Update offset on scroll
  $(window).on('scroll resize', function () {
    headerOffset();
  });
  if ($(window).scrollTop() >= 200) {
    $('.fixed-wrap').addClass('scrolling');
  }
  ;

  // Offset content from fixed header
  function headerOffset() {
    var headerHeight = $('.fixed-wrap').innerHeight();
    $('#main').css('padding-top', headerHeight + 'px');
    $('.pdp__images').css('top', headerHeight + 'px');
    // $( '.mobile-menu__inner, .mini-cart' ).css( 'height', 'calc( 100vh - '+headerHeight+'px )' );

    $(window).on('scroll resize', function () {
      var newsHeight = $('.fixed-wrap .alert-bar').innerHeight();
      if ($(window).scrollTop() >= 100 || $('body').hasClass('template__product') && $(window).scrollTop() > 0) {
        $('.fixed-wrap').addClass('scrolling');
        if (newsHeight != undefined) {
          if ($('.alert-bar').css('display') === 'none') {
            $('.fixed-wrap').css('transform', 'translateY(0)');
          } else {
            $('.fixed-wrap').css('transform', 'translateY(-' + newsHeight + 'px)');
          }
        }
        $('.mobile-menu__inner').css('height', 'calc( 100vh - ' + headerHeight + 'px )');
      } else {
        $('.fixed-wrap').removeClass('scrolling');
        $('.fixed-wrap').css('transform', 'translateY(0)');
      }
    });
  }
});
jQuery(document).ready(function ($) {
  // Close mini cart
  $('.mini-cart__bg, .mini-cart__content .close, #empty_close').on('click', function () {
    closeMini();
  });

  // Close mini cart with ESC key
  $(document).on('keydown', function (event) {
    if (event.key === "Escape") {
      if ($('body').hasClass('cart-open')) {
        closeMini();
      }
    }
  });

  // Show mini cart
  $('.header .icon--cart').on('click', function (e) {
    e.preventDefault();
    if (!$('body').hasClass('template__cart')) {
      showMini();
      $('.mini-cart__content .close').focus();
    } else {
      e.preventDefault();
    }
  });

  // Mini Cart Remove Product
  $('.mini-cart').on('click', '.remove-product', function () {
    var lineNum = $(this).closest('.product').attr('data-lineid');
    $(this).closest('.product').addClass('removed');
    CartJS.removeItem(lineNum, {
      success: function success(data, textStatus, jqXHR) {
        jQuery.getJSON('/cart.js', function (cart) {
          refreshMiniCart(cart);
        });
      },
      error: function error(jqXHR, textStatus, errorThrown) {
        console.log(errorThrown);
      }
    });
  });

  // Mini Cart Upsell ATC
  $('.mini-cart__upsell .action--atc').on('click', function (e) {
    e.preventDefault();
    var dataId = $(this).closest('.upsell').attr('data-id');
    CartJS.addItem(dataId, 1, {}, {
      success: function success(data, textStatus, jqXHR) {
        jQuery.getJSON('/cart.js', function (cart) {
          refreshMiniCart(cart);
        });
      },
      error: function error(jqXHR, textStatus, errorThrown) {
        console.log(errorThrown);
      }
    });
  });

  // Mini Cart Qty
  $('.mini-cart__list').off('click', '.js-qty--mini').on('click', '.js-qty--mini', function (e) {
    console.log("Click event triggered");
    e.preventDefault();
    var $this = $(this);
    var $parent = $this.parent();
    var qtyInput = $parent.find('input');
    var qtyInputVal = qtyInput.val();
    console.log("Initial quantity: " + qtyInputVal); // Log initial quantity
    qtyInputVal = $.isNumeric(qtyInputVal) ? qtyInputVal : 0;
    var lineData = $this.closest('.product').data('lineid');
    var lineNum = $('[data-lineID="' + lineData + '"]').index();
    var updatedQtyInputVal = qtyInputVal;
    if ($this.hasClass('js-qty--plus')) {
      console.log("Increase button clicked");
      updatedQtyInputVal++;
      updatedQtyInputVal = updatedQtyInputVal < 0 ? 1 : updatedQtyInputVal;
    } else {
      console.log("Decrease button clicked");
      updatedQtyInputVal--;
      updatedQtyInputVal = updatedQtyInputVal < 0 ? 0 : updatedQtyInputVal;
    }
    console.log("Updated quantity (to be set): " + updatedQtyInputVal); // Log updated quantity

    console.log("Update cart item");
    CartJS.updateItem(lineNum + 1, updatedQtyInputVal, {}, {
      success: function success(data, textStatus, jqXHR) {
        console.log("Update successful");
        jQuery.getJSON('/cart.js', function (cart) {
          refreshMiniCart(cart);
        });
      },
      error: function error(jqXHR, textStatus, errorThrown) {
        console.log("Error updating item");
        jQuery.getJSON('/cart.js', function (cart) {
          refreshMiniCart(cart);
        });
        var response = jqXHR.responseJSON;
        var message = jqXHR.responseJSON.message;
        console.log(response);
        if (jqXHR.status === 422) {
          alert('Error: ' + message);
        }
      }
    });
  });
});
function closeMini() {
  $('body').removeClass('cart-open');
  $('.mini-cart').removeClass('is-open');
  $('.mini-cart').fadeOut('fast');
}
function showMini() {
  $('body').addClass('cart-open');
  $('.mini-cart').fadeIn('fast');
  $('.mini-cart').addClass('is-open');

  // Set height of product list for full-height mini-cart
  // var miniHead = parseInt( $( '.mini-cart__header' ).innerHeight() );
  // var miniShip = parseInt( $( '.mini-cart__ship' ).innerHeight() );
  // var miniFooter = parseInt( $( '.mini-cart__footer' ).innerHeight() );
  // var miniUp = parseInt( $( '.mini-cart__upsell' ).innerHeight() );
  // var miniTotalHeight = miniHead + miniShip + miniFooter + miniUp;
}

function refreshMiniCart(cartData) {
  var cartItems = cartData.items;
  var newCartHtml = '';

  // Free shipping updater
  var totalShip = parseInt($('.mini-cart').data('freeship'));
  var newCartTotal = cartData.items_subtotal_price;
  var awayShip = totalShip - newCartTotal;
  var shipPercent = newCartTotal / totalShip * 100;
  if (shipPercent >= 100) {
    $('.shipping-bar--progress').css('width', '100%');
    $('.mini-cart__ship').addClass('is-free');
  } else {
    if ($('.mini-cart__ship').hasClass('is-free')) {
      $('.mini-cart__ship').removeClass('is-free');
    }
    $('.free-count').text(formatter.format(awayShip / 100));
    $('.shipping-bar--progress').css('width', shipPercent + '%');
  }

  // Build html of new products in cart
  $.each(cartItems, function (index, item) {
    // console.log(item);

    // Opening
    newCartHtml += '<div class="product product--cart d-flex justify-between" data-lineid="' + (index + 1) + '" data-varid="' + item.id + '">';
    newCartHtml += ' <div class="product__image">';
    if (item.featured_image) {
      newCartHtml += '<a href="' + item.url + '">';
      newCartHtml += '<img src="' + item.featured_image.url.replace('.jpg', '_80x.jpg').replace('.png', '_80x.png') + '" srcset="' + item.featured_image.url.replace('.jpg', '_160x.jpg').replace('.png', '_160x.png') + ' 2x" alt="' + item.title + '">';
      newCartHtml += '</a>';
    }
    newCartHtml += '</div>';
    newCartHtml += '<div class="product__info">';
    newCartHtml += '<div class="title d-flex">';
    newCartHtml += '<h3 class="paragraph d-flex justify-between">';
    newCartHtml += '<a class="no-dec trans" href="' + item.url + '">';
    newCartHtml += item.product_title;
    newCartHtml += '</a>';
    newCartHtml += ' <button class="remove-product trans"><span class="sr-only">Remove</span><img src="https://cdn.shopify.com/s/files/1/0250/8311/7615/files/modal-close.svg?v=1689107517" alt="" /></button>';
    newCartHtml += '</h3>';
    if (item.options_with_values && item.options_with_values.length > 0) {
      item.options_with_values.forEach(function (option) {
        newCartHtml += '<span class="var">' + option.name + ': ' + option.value + '</span>';
      });
    }
    if (item.selling_plan_allocation && item.selling_plan_allocation.selling_plan.name) {
      newCartHtml += '<span class="delivery">' + item.selling_plan_allocation.selling_plan.name + '</span>';
    }
    newCartHtml += '</div>';
    newCartHtml += '<div class="actions d-flex align-center justify-between">';
    newCartHtml += '<div class="action action--qty">';
    newCartHtml += '<div class="qty d-flex align-center">';
    newCartHtml += '<button class="js-qty js-qty--mini js-qty--minus trans"><span class="sr-only">Decrease</span></button>';
    newCartHtml += '<input readonly sm-rc-quantity-selector aria-label="Quantity" value="' + item.quantity + '" min="1" type="number" class="qty-val" />';
    newCartHtml += '<button class="js-qty js-qty--mini js-qty--plus trans"><span class="sr-only">Increase</span></button>';
    newCartHtml += '</div>';
    newCartHtml += '</div>';
    newCartHtml += '<div class="price">' + formatter.format(item.final_line_price / 100) + '</div>';
    newCartHtml += '</div>';

    // Closing
    newCartHtml += '</div>';
    newCartHtml += '</div>';
  });

  // Clear current products in cart
  $('.mini-cart__items').empty();

  // Set new subtotal
  $('.mini-cart__footer .sub-total .total').text(formatter.format(cartData.total_price / 100));

  // Set new header icon count
  $('.icon--cart .cart-count span ').text(cartData.item_count);
  if (cartData.item_count == "0") {
    $('.cart__empty').show();
    $('.mini-cart__footer').hide();
  } else {
    $('.cart__empty').hide();
    $('.mini-cart__footer').show();
  }

  // Add updated producst to mini cart
  $('.mini-cart__list').html(newCartHtml);

  // Show mini cart
  showMini();
}
$(document).ready(function () {
  // Hover Zoom for desktop PDP images
  $('.pdp__images--item').each(function () {
    var child = $(this).children().first();
    if (child.is('img')) {
      var zoomImage = child.attr('data-zoomimg');
      $(this).zoom({
        url: zoomImage,
        lazyLoad: true,
        touch: false,
        magnify: 1
      });
    }
  });
});
jQuery(document).ready(function ($) {
  $('.slider').each(function () {
    var $this = $(this);
    var myInterval = setInterval(function () {
      if ($this.hasClass('slider')) {
        $this.animate({
          opacity: 1
        });
        $this.slick('setPosition');
        clearInterval(myInterval);
      }
    }, 150);
  });
});
function initializeSliders() {
  $('.slider').each(function () {
    var $this = $(this);
    var myInterval = setInterval(function () {
      if ($this.hasClass('slider')) {
        $this.animate({
          opacity: 1
        });
        $this.slick('setPosition');
        clearInterval(myInterval);
      }
    }, 150);
  });

  // Alert bar slider
  $('.alert-bar__slider').not('.slick-initialized').slick({
    infinite: true,
    slideToShow: 1,
    vertical: true,
    autoplay: true,
    centerMode: false,
    dots: false,
    arrows: false,
    adaptiveHeight: true,
    autoplaySpeed: 3500
  });

  // Hero--full Slider
  $('.hero--full .hero__slider').not('.slick-initialized').slick({
    accessibility: false,
    fade: true,
    infinite: true,
    slidesToShow: 1,
    slidesToScroll: 1,
    centerMode: false,
    arrows: true,
    dots: true,
    responsive: [{
      breakpoint: 576,
      settings: {
        arrows: false
      }
    }]
  });

  // Hero--split Slider
  $('.hero--split .hero__slider').not('.slick-initialized').slick({
    accessibility: false,
    fade: true,
    infinite: true,
    slidesToShow: 1,
    slidesToScroll: 1,
    centerMode: false,
    arrows: true,
    dots: true,
    appendDots: '.hero--split .split--dots',
    responsive: [{
      breakpoint: 576,
      settings: {
        arrows: false
      }
    }]
  });

  // Hero--split-flip Slider
  $('.hero--split-flip .hero__slider').not('.slick-initialized').slick({
    accessibility: false,
    fade: true,
    infinite: true,
    slidesToShow: 1,
    slidesToScroll: 1,
    centerMode: false,
    arrows: true,
    dots: true,
    appendDots: '.hero--split-flip .split--dots',
    responsive: [{
      breakpoint: 576,
      settings: {
        arrows: false
      }
    }]
  });

  // PDP Default image slider
  // $( '.pdp__images--default .pdp__slider--thumb' ).slick({
  //   accessibility: false,
  //   infinite: true,
  //   arrows: true,
  //   dots: false,
  //   slidesToShow: 5,
  //   vertical: true,
  //   focusOnSelect: true,
  //   asNavFor: '.pdp__images--default .pdp__slider--main',
  //   responsive: [
  //   {
  //     breakpoint: 1280,
  //     settings: {
  //       slidesToShow: 4,
  //     }
  //   },
  //   {
  //     breakpoint: 768,
  //     settings: {
  //       slidesToShow: 4,
  //       vertical: false
  //     }
  //   }
  //   ]
  // })

  $('.pdp__images--default .pdp__slider--main').not('.slick-initialized').slick({
    slidesToShow: 1,
    accessibility: false,
    infinite: true,
    fade: true,
    arrows: true,
    dots: false
    // asNavFor: '.pdp__images--default .pdp__slider--thumb'
  });

  // Event testimonials
  $('.event__testimonials--slider').not('.slick-initialized').slick({
    fade: true,
    infinite: true,
    slidesToShow: 1,
    slidesToScroll: 1,
    centerMode: false,
    arrows: true,
    dots: true
  });

  // Instagram Slider
  $('.instagram__slider--js').not('.slick-initialized').slick({
    infinite: false,
    slidesToShow: 4,
    slidesToScroll: 1,
    centerMode: false,
    arrows: false,
    dots: false,
    responsive: [{
      breakpoint: 480,
      settings: {
        slidesToShow: 1,
        arrows: true
      }
    }, {
      breakpoint: 576,
      settings: {
        slidesToShow: 2,
        arrows: true
      }
    }, {
      breakpoint: 768,
      settings: {
        slidesToShow: 2,
        arrows: true
      }
    }, {
      breakpoint: 992,
      settings: {
        slidesToShow: 3,
        arrows: true
      }
    }, {
      breakpoint: 1280,
      settings: {
        slidesToShow: 4
      }
    }]
  });

  // Puppers Slider
  $('.puppers__slider--js').not('.slick-initialized').slick({
    infinite: true,
    slidesToShow: 4,
    slidesToScroll: 1,
    centerMode: false,
    arrows: true,
    dots: false,
    responsive: [{
      breakpoint: 1104,
      settings: {
        slidesToShow: 3
      }
    }, {
      breakpoint: 768,
      settings: {
        slidesToShow: 2
      }
    }, {
      breakpoint: 576,
      settings: {
        slidesToShow: 1
      }
    }]
  });

  // cart upsells
  $('.product-carousel--upsells .carousel__slider').not('.slick-initialized').slick({
    infinite: false,
    slidesToShow: 4,
    slidesToScroll: 1,
    arrows: true,
    dots: false,
    responsive: [{
      breakpoint: 440,
      settings: {
        slidesToShow: 1
      }
    }, {
      breakpoint: 768,
      settings: {
        slidesToShow: 2
      }
    }, {
      breakpoint: 1104,
      settings: {
        slidesToShow: 3
      }
    }]
  });

  // Swatches Home Slider
  $('.swatches__slider--js').not('.slick-initialized').slick({
    infinite: false,
    slidesToShow: 6,
    slidesToScroll: 1,
    centerMode: false,
    arrows: true,
    dots: false,
    responsive: [{
      breakpoint: 480,
      settings: {
        slidesToShow: 1.5
      }
    }, {
      breakpoint: 576,
      settings: {
        slidesToShow: 2
      }
    }, {
      breakpoint: 768,
      settings: {
        slidesToShow: 3
      }
    }, {
      breakpoint: 992,
      settings: {
        slidesToShow: 4
      }
    }, {
      breakpoint: 1280,
      settings: {
        slidesToShow: 5
      }
    }]
  });

  // PLP Styles Slider
  $('.collection_styles--slider').not('.slick-initialized').slick({
    infinite: false,
    slidesToShow: 6,
    slidesToScroll: 1,
    centerMode: false,
    arrows: true,
    dots: false,
    responsive: [{
      breakpoint: 1104,
      settings: {
        slidesToShow: 4,
        infinite: true
      }
    }, {
      breakpoint: 768,
      settings: {
        slidesToShow: 3,
        infinite: true
      }
    }, {
      breakpoint: 576,
      settings: {
        slidesToShow: 2,
        infinite: true
      }
    }]
  });

  // PLP Styles Slider Mobile
  $('.collection_styles--slider-mobile').not('.slick-initialized').slick({
    infinite: false,
    slidesToShow: 2,
    slidesToScroll: 1,
    centerMode: false,
    arrows: true,
    dots: false
  });
}
function reinitSliders() {
  destroySliders();
  console.log("Destroyed Sliders");
  initializeSliders();
  console.log("Initialized Sliders");

  // $('.slider').slick('setPosition');
}

function destroySliders() {
  // Alert bar slider
  $('.alert-bar__slider.slick-initialized').slick('unslick');

  // Hero--full Slider
  $('.hero--full .hero__slider.slick-initialized').slick('unslick');

  // Hero--split Slider
  $('.hero--split .hero__slider.slick-initialized').slick('reinit');

  // Hero--split-flip Slider
  $('.hero--split-flip .hero__slider.slick-initialized.slick-initialized').slick('reinit');
  $('.pdp__images--default .pdp__slider--main.slick-initialized').slick('reinit');

  // Event testimonials
  $('.event__testimonials--slider.slick-initialized').slick('reinit');

  // Instagram Slider
  $('.instagram__slider--js.slick-initialized').slick('reinit');

  // Puppers Slider
  $('.puppers__slider--js.slick-initialized').slick('reinit');

  // cart upsells
  $('.product-carousel--upsells .carousel__slider.slick-initialized').slick('reinit');

  // Swatches Home Slider
  $('.swatches__slider--js.slick-initialized').slick('reinit');

  // PLP Styles Slider
  $('.collection_styles--slider.slick-initialized').slick('reinit');

  // PLP Styles Slider Mobile
  $('.collection_styles--slider-mobile.slick-initialized').slick('reinit');
}

// On document ready and Shopify section load/select, initialize sliders
$(document).ready(initializeSliders);
$(document).on('shopify:section:load', reinitSliders);
$(document).on('shopify:section:select', reinitSliders);

// $('.slider').on('load', 'img', function() {
//   $('.slider').slick('reinit');
// });

// On Shopify section unload, destroy sliders
$(document).on('shopify:section:unload', destroySliders);